// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import { isolateComponent } from '@zapier/common-utils';
import { Colors, IconButton, type IconName } from '@zapier/design-system';

/** @jsx isolateComponent */

type Props = {
  /**
   * ARIA attribute indicating whether or not the content
   * controlled by the button is visible.
   */
  ariaExpanded: boolean,
  /**
   * Name of the `Icon` to render.
   */
  icon: IconName,
  /**
   *  Indicates what the button does. Used for the `ariaLabel` on the
   * `Button` as well as the text for the `Tooltip`.
   * This prop should be supplied in most circumstances, but in cases
   * **when it's not desired be sure to pass `ariaLabel`!**
   */
  label: string,
  /** Callback to be executed when the button is clicked. */
  onClick?: (e: SyntheticEvent<>) => void,
  /** Size of the button */
  size: 'small' | 'medium',
};

const MenuCollapseButtonTheme = {
  custom: {
    base: {
      backgroundColor: 'transparent',
      color: Colors.grey700,
    },
    disabled: {
      backgroundColor: 'transparent',
      color: Colors.grey100,
    },
    hover: {
      backgroundColor: Colors.grey100,
      color: Colors.grey700,
    },
    focus: {
      backgroundColor: Colors.grey100,
      color: Colors.grey700,
      outlineColor: Colors.transparent,
    },
  },
};
/**
 * MenuCollapseButton renders a themed IconButton.
 */
const MenuCollapseButton = (props: Props) => (
  <IconButton
    ariaExpanded={props.ariaExpanded}
    color="custom"
    colorTheme={MenuCollapseButtonTheme}
    icon={props.icon}
    isPill={true}
    label={props.label}
    onClick={(event: SyntheticEvent<>) => {
      if (props.onClick) {
        props.onClick(event);
      }
    }}
    size={props.size}
    tooltipPosition="east"
  />
);

MenuCollapseButton.defaultProps = {
  ariaExpanded: false,
  icon: 'navMenu',
  label: 'Menu',
  size: 'medium',
};

export default MenuCollapseButton;
